import React from "react";

const Columns = (addUpd, changePassword) => {
  let columns = [
    {
      id: "name",
      name: "Nombre",
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
    },
    {
      id: "admin",
      name: "Admin",
      selector: (row) => `${row.admin?.name} - ${row.admin?.email}`,
      sortable: true,
      wrap: true,
    },
    {
      id: "actions",
      name: "Acciones",
      width: "10%",
      button: true,
      cell: (row) => (
        <div className="d-flex justify-content-between">
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Editar usuario"
              onClick={() => addUpd(row)}
            >
              <i className="fas fa-edit"></i>
            </button>
          </div>
          <div className="p-2">
            <button
              className="btn btn-primary btn-sm"
              title="Cambiar contraseña"
              onClick={() => changePassword(row)}
            >
              <i className="fas fas fa-user-lock"></i>
            </button>
          </div>
        </div>
      ),
    },
  ];
  return columns;
};

export default Columns;
